// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageSectionForm_wrapper__3Z_yb","container":"ImageSectionForm_container__gbVaC","border_blur":"ImageSectionForm_border_blur__39NEE"};